module.exports = __webpack_public_path__ + "static/media/details-screen-1.fd37fa32.png";